import { SetTableActionType } from "models/actionTypes/tableActionTypes";
import { ContextConstants } from "utils/constants";
import { TableContextState } from "models/propTypes/simpleTableProps";

export const TableReducer = (state: TableContextState, action: SetTableActionType) => {
  switch (action.type) {
    case ContextConstants.TableActions.SET_TABLE_FILTER:
      return { ...state, filter: action.payload };
    default:
      return state;
  }
};
